export default __webpack_public_path__ + "static/video-img08-bc166951e79c258cef3613c8cb854724.jpg";